module.exports = __webpack_public_path__ + "img/banner2_9_zh.1b8f6a6d.png";